import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './plugins/services'
import './plugins/axios'
import i18n from './i18n'
import {LocaleData, registerLocale} from "i18n-iso-countries";
import './scss/main.scss';

const countriesEn: LocaleData = require("i18n-iso-countries/langs/en.json") as LocaleData;
const countriesDe: LocaleData = require("i18n-iso-countries/langs/de.json") as LocaleData;
registerLocale(countriesEn);
registerLocale(countriesDe);

Vue.config.productionTip = false;
new Vue({
	router,
	store,
	vuetify,
	i18n,
	render: h => h(App)
}).$mount('#app');
